// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmptyContent_empty-content__zlK3E {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4rem;
}

.EmptyContent_empty-content__icon-wrapper__zSGzr {
  padding: 3.5rem;
  background-color: var(--primary-color-20-opacity);
  border-radius: 50%;
}

.EmptyContent_empty-content__message__HNORL {
  color: #000;
  font-size: var(--text-base);
  font-weight: 700;
  text-align: center;
}

.EmptyContent_empty-content__action-btn__2iYKS {
  padding: 1.9rem 11rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/EmptyContent/EmptyContent.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".empty-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4rem;\n}\n\n.empty-content__icon-wrapper {\n  padding: 3.5rem;\n  background-color: var(--primary-color-20-opacity);\n  border-radius: 50%;\n}\n\n.empty-content__message {\n  color: #000;\n  font-size: var(--text-base);\n  font-weight: 700;\n  text-align: center;\n}\n\n.empty-content__action-btn {\n  padding: 1.9rem 11rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"empty-content": `EmptyContent_empty-content__zlK3E`,
	"empty-content__icon-wrapper": `EmptyContent_empty-content__icon-wrapper__zSGzr`,
	"empty-content__message": `EmptyContent_empty-content__message__HNORL`,
	"empty-content__action-btn": `EmptyContent_empty-content__action-btn__2iYKS`
};
export default ___CSS_LOADER_EXPORT___;
